"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var Icon_1 = tslib_1.__importDefault(require("../../Icon"));

var Button_1 = tslib_1.__importDefault(require("../../Buttons/Button"));

var TextButton_1 = tslib_1.__importDefault(require("../../Buttons/TextButton"));

var hooks_1 = require("../../../hooks");

var helper_1 = require("../../../styles/helper");

var styles = tslib_1.__importStar(require("./BottomSheet.style"));

function BottomSheet(_ref) {
  var _ref$modalKey = _ref.modalKey,
      modalKey = _ref$modalKey === void 0 ? '' : _ref$modalKey,
      className = _ref.className,
      children = _ref.children,
      isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      title = _ref.title,
      titleOptionButtonContent = _ref.titleOptionButtonContent,
      isAboveDialog = _ref.isAboveDialog,
      _ref$preventParentScr = _ref.preventParentScroll,
      preventParentScroll = _ref$preventParentScr === void 0 ? false : _ref$preventParentScr,
      _ref$showBackDrop = _ref.showBackDrop,
      showBackDrop = _ref$showBackDrop === void 0 ? false : _ref$showBackDrop,
      confirmButtonContent = _ref.confirmButtonContent,
      _ref$disabledConfirmB = _ref.disabledConfirmButton,
      disabledConfirmButton = _ref$disabledConfirmB === void 0 ? false : _ref$disabledConfirmB,
      optionButtonContent = _ref.optionButtonContent,
      _ref$disabledOptionBu = _ref.disabledOptionButton,
      disabledOptionButton = _ref$disabledOptionBu === void 0 ? false : _ref$disabledOptionBu,
      onConfirmClick = _ref.onConfirmClick,
      onOptionClick = _ref.onOptionClick,
      onTitleOptionClick = _ref.onTitleOptionClick;

  function handleClosableClick() {
    toggle(false);
  }

  function handleConfirmClick() {
    onConfirmClick && onConfirmClick();
  }

  function handleOptionClick() {
    onOptionClick && onOptionClick();
  }

  function handleTitleOptionClick() {
    onTitleOptionClick && onTitleOptionClick();
  }

  react_1.useEffect(function () {
    if (!preventParentScroll) {
      return;
    }

    if (isOpen) {
      document.body.setAttribute('style', 'overflow: hidden');
      return;
    }

    document.body.setAttribute('style', '');
  }, [isOpen, preventParentScroll]);
  hooks_1.useModalHistory(modalKey, isOpen, handleClosableClick);
  return jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [react_dom_1.createPortal(jsx_runtime_1.jsxs("div", Object.assign({
      role: "dialog",
      className: className,
      css: [styles.container, isOpen ? styles.bottomSheetShow : styles.bottomSheetHide, isAboveDialog && styles.isAboveDialog, helper_1.getBottomSafeAreaPadding()]
    }, {
      children: [title && jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.title
      }, {
        children: [jsx_runtime_1.jsx(Icon_1.default, {
          name: "ic_close_sm_gray_500",
          alt: "close",
          onClick: handleClosableClick
        }, void 0), jsx_runtime_1.jsx("div", Object.assign({
          css: styles.titleTextWrapper
        }, {
          children: title
        }), void 0), titleOptionButtonContent && jsx_runtime_1.jsx("div", Object.assign({
          css: styles.titleOption
        }, {
          children: jsx_runtime_1.jsx(TextButton_1.default, Object.assign({
            css: styles.titleOptionButton,
            size: "medium",
            onClick: handleTitleOptionClick
          }, {
            children: titleOptionButtonContent
          }), void 0)
        }), void 0)]
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({
        className: "mrt-bottom-sheet-content",
        css: [styles.content, confirmButtonContent && styles.confirmButtonPadding]
      }, {
        children: children
      }), void 0), confirmButtonContent && jsx_runtime_1.jsxs("div", Object.assign({
        css: [styles.footer, helper_1.getBottomSafeAreaPadding(12)]
      }, {
        children: [optionButtonContent && jsx_runtime_1.jsx("div", Object.assign({
          css: styles.optionButton
        }, {
          children: jsx_runtime_1.jsx(Button_1.default, Object.assign({
            css: styles.optionButton,
            disabled: disabledOptionButton,
            type: "gray",
            size: "large",
            onClick: handleOptionClick
          }, {
            children: optionButtonContent
          }), void 0)
        }), void 0), jsx_runtime_1.jsx("span", Object.assign({
          css: styles.confirmButton
        }, {
          children: jsx_runtime_1.jsx(Button_1.default, Object.assign({
            disabled: disabledConfirmButton,
            type: "primary",
            size: "large",
            onClick: handleConfirmClick
          }, {
            children: confirmButtonContent
          }), void 0)
        }), void 0)]
      }), void 0)]
    }), void 0), document.body), showBackDrop && jsx_runtime_1.jsx("div", {
      className: className,
      css: [styles.backdrop, isOpen ? styles.backdropShow : styles.backdropHide, isAboveDialog && styles.isAboveDialog],
      onClick: handleClosableClick
    }, void 0)]
  }, void 0);
}

exports.default = BottomSheet;